import { useMemo } from 'react';
import TypePlaceSensitivtyVariant4 from './TypePlaceSensitivtyVariant4';
// import C$167:7916$ from "F$167:7916$";

const CardProduct = ({ urlImage, rectangle20, thaiFoodBuffetLowSoundGre, product, iconSet, iconSet1, vector43, iconSet2, iconSet3, iconSet4, iconSet5, iconSet6, iconSet7, iconSet8, iconSet9, iconSet10, iGoHereRegularlyWithMyPat, showTags, tagsVisible, tagsVisible1, tagsVisible2, tagsVisible3, tagsVisible4, tagsVisible5, tagsVisible6, propFlex, propPadding, propBackgroundColor, propBackgroundColor1, propBackgroundColor2, propBackgroundColor3, propBackgroundColor4, propBackgroundColor5, propBackgroundColor6, propBackgroundColor7, propBackgroundColor8, propBackgroundColor9, propBackgroundColor10, propBackgroundColor11, propBackgroundColor12, propBorderLeft }) => {
  const property1ProductStyle = useMemo(() => {
                  return {
                    flex: propFlex
                  };
                }, [propFlex]);
              
  const detailsWrapperStyle = useMemo(() => {
                  return {
                    padding: propPadding
                  };
                }, [propPadding]);
              
  const frameDiv1Style = useMemo(() => {
                  return {
                    backgroundColor: propBackgroundColor
                  };
                }, [propBackgroundColor]);
              
  const typePlaceSensitivtyVariantStyle = useMemo(() => {
                  return {
                    backgroundColor: propBackgroundColor1
                  };
                }, [propBackgroundColor1]);
              
  const typePlaceSensitivtyVariantStyle1 = useMemo(() => {
                  return {
                    backgroundColor: propBackgroundColor2
                  };
                }, [propBackgroundColor2]);
              
  const tagsStyle = useMemo(() => {
                  return {
                    backgroundColor: propBackgroundColor3
                  };
                }, [propBackgroundColor3]);
              
  const typePlaceSensitivtyVariantStyle2 = useMemo(() => {
                  return {
                    backgroundColor: propBackgroundColor4
                  };
                }, [propBackgroundColor4]);
              
  const typePlaceSensitivtyVariantStyle3 = useMemo(() => {
                  return {
                    backgroundColor: propBackgroundColor5
                  };
                }, [propBackgroundColor5]);
              
  const typePlaceSensitivtyVariantStyle4 = useMemo(() => {
                  return {
                    backgroundColor: propBackgroundColor6
                  };
                }, [propBackgroundColor6]);
              
  const typePlaceSensitivtyVariantStyle5 = useMemo(() => {
                  return {
                    backgroundColor: propBackgroundColor7
                  };
                }, [propBackgroundColor7]);
              
  const typePlaceSensitivtyVariantStyle6 = useMemo(() => {
                  return {
                    backgroundColor: propBackgroundColor8
                  };
                }, [propBackgroundColor8]);
              
  const typePlaceSensitivtyVariantStyle7 = useMemo(() => {
                  return {
                    backgroundColor: propBackgroundColor9
                  };
                }, [propBackgroundColor9]);
              
  const typePlaceSensitivtyVariantStyle8 = useMemo(() => {
                  return {
                    backgroundColor: propBackgroundColor10
                  };
                }, [propBackgroundColor10]);
              
  const typePlaceSensitivtyVariantStyle9 = useMemo(() => {
                  return {
                    backgroundColor: propBackgroundColor11
                  };
                }, [propBackgroundColor11]);
              
  const typePlaceSensitivtyVariantStyle10 = useMemo(() => {
                  return {
                    backgroundColor: propBackgroundColor12
                  };
                }, [propBackgroundColor12]);
              
  const quoteWrapperStyle = useMemo(() => {
                  return {
                    borderLeft: propBorderLeft
                  };
                }, [propBorderLeft]);
              

  return (
    <div className="self-stretch flex-1 rounded-3xl bg-light overflow-hidden flex flex-col items-center justify-start gap-[16px] text-left text-xs text-dark font-footnote border-b-[4px] border-solid border-lavender md:hidden" style={property1ProductStyle}>
      <img className="self-stretch relative max-w-full overflow-hidden h-[233px] shrink-0 object-cover" alt="" src={urlImage} />
      <div className="self-stretch flex flex-col pt-4 px-4 pb-8 items-start justify-start gap-[32px]">
        <div className="self-stretch flex flex-col items-start justify-start gap-[16px]">
          <div className="self-stretch flex flex-row items-start justify-start gap-[16px] text-5xl">
            <img className="relative rounded-11xl w-11 h-11 object-cover" alt="" src={rectangle20} />
            <b className="flex-1 relative">{thaiFoodBuffetLowSoundGre}</b>
          </div>
          <div className="self-stretch flex flex-row py-2 px-0 items-center justify-start gap-[4px] border-b-[1px] border-solid border-darkslategray-200" style={detailsWrapperStyle}>
            <div className="bg-sky-blue-100 flex flex-row items-center justify-start" style={frameDiv1Style}>
              <b className="relative">{product}</b>
            </div>
            <div className="relative rounded-[50%] bg-dark w-1 h-1" />
            <div className="relative">134 1st Ave, New York, NY</div>
          </div>
          <b className="relative">Good for the following sensitivities</b>
          <div className="self-stretch flex flex-row flex-wrap items-start justify-start gap-[6px] text-sm font-h2-accent"><TypePlaceSensitivtyVariant4 iconSet="/icon-set15.svg" lifestyle="Staff" typePlaceSensitivtyLifestPosition="unset" typePlaceSensitivtyLifestTop="unset" typePlaceSensitivtyLifestLeft="unset" typePlaceSensitivtyLifestBackgroundColor="#e5f7ff" iconSetOverflow="unset" iconSetFlexShrink="unset" /><TypePlaceSensitivtyVariant4 iconSet="/icon-set16.svg" lifestyle="Taste" typePlaceSensitivtyLifestPosition="unset" typePlaceSensitivtyLifestTop="unset" typePlaceSensitivtyLifestLeft="unset" typePlaceSensitivtyLifestBackgroundColor="#e5f7ff" iconSetOverflow="unset" iconSetFlexShrink="unset" />
            <div className="rounded bg-sky-blue-100 flex flex-row p-2.5 items-center justify-center gap-[10px]" style={tagsStyle}>
              <div className="w-6 h-6 flex flex-row p-2.5 box-border items-center justify-center">
                <img className="relative w-[18.53px] h-[21.04px]" alt="" src={vector43} />
              </div>
              <div className="relative font-medium">Odors</div>
            </div><TypePlaceSensitivtyVariant4 iconSet="/icon-set30.svg" lifestyle="Visual " typePlaceSensitivtyLifestPosition="unset" typePlaceSensitivtyLifestTop="unset" typePlaceSensitivtyLifestLeft="unset" typePlaceSensitivtyLifestBackgroundColor="#e5f7ff" iconSetOverflow="unset" iconSetFlexShrink="unset" /><TypePlaceSensitivtyVariant4 iconSet="/icon-set30.svg" lifestyle="Visual " typePlaceSensitivtyLifestPosition="unset" typePlaceSensitivtyLifestTop="unset" typePlaceSensitivtyLifestLeft="unset" typePlaceSensitivtyLifestBackgroundColor="#e5f7ff" iconSetOverflow="unset" iconSetFlexShrink="unset" /><TypePlaceSensitivtyVariant4 iconSet="/icon-set30.svg" lifestyle="Visual " typePlaceSensitivtyLifestPosition="unset" typePlaceSensitivtyLifestTop="unset" typePlaceSensitivtyLifestLeft="unset" typePlaceSensitivtyLifestBackgroundColor="#e5f7ff" iconSetOverflow="unset" iconSetFlexShrink="unset" /><TypePlaceSensitivtyVariant4 iconSet="/icon-set30.svg" lifestyle="Visual " typePlaceSensitivtyLifestPosition="unset" typePlaceSensitivtyLifestTop="unset" typePlaceSensitivtyLifestLeft="unset" typePlaceSensitivtyLifestBackgroundColor="#e5f7ff" iconSetOverflow="unset" iconSetFlexShrink="unset" /><TypePlaceSensitivtyVariant4 iconSet="/icon-set30.svg" lifestyle="Visual " typePlaceSensitivtyLifestPosition="unset" typePlaceSensitivtyLifestTop="unset" typePlaceSensitivtyLifestLeft="unset" typePlaceSensitivtyLifestBackgroundColor="#e5f7ff" iconSetOverflow="unset" iconSetFlexShrink="unset" /><TypePlaceSensitivtyVariant4 iconSet="/icon-set30.svg" lifestyle="Visual " typePlaceSensitivtyLifestPosition="unset" typePlaceSensitivtyLifestTop="unset" typePlaceSensitivtyLifestLeft="unset" typePlaceSensitivtyLifestBackgroundColor="#e5f7ff" iconSetOverflow="unset" iconSetFlexShrink="unset" /><TypePlaceSensitivtyVariant4 iconSet="/icon-set30.svg" lifestyle="Visual " typePlaceSensitivtyLifestPosition="unset" typePlaceSensitivtyLifestTop="unset" typePlaceSensitivtyLifestLeft="unset" typePlaceSensitivtyLifestBackgroundColor="#e5f7ff" iconSetOverflow="unset" iconSetFlexShrink="unset" /><TypePlaceSensitivtyVariant4 iconSet="/icon-set30.svg" lifestyle="Visual " typePlaceSensitivtyLifestPosition="unset" typePlaceSensitivtyLifestTop="unset" typePlaceSensitivtyLifestLeft="unset" typePlaceSensitivtyLifestBackgroundColor="#e5f7ff" iconSetOverflow="unset" iconSetFlexShrink="unset" /><TypePlaceSensitivtyVariant4 iconSet="/icon-set30.svg" lifestyle="Visual " typePlaceSensitivtyLifestPosition="unset" typePlaceSensitivtyLifestTop="unset" typePlaceSensitivtyLifestLeft="unset" typePlaceSensitivtyLifestBackgroundColor="#e5f7ff" iconSetOverflow="unset" iconSetFlexShrink="unset" />
          </div>
        </div>
        <div className="self-stretch flex flex-row py-0 pr-0 pl-4 items-start justify-start text-xl font-h2-accent border-l-[4px] border-solid border-aliceblue-100" style={quoteWrapperStyle}>
          <div className="flex-1 relative font-medium">{iGoHereRegularlyWithMyPat}</div>
        </div>
      </div>
    </div>);
};

export default CardProduct;
